import { AccountOptionOffer } from "./account-option-offer.entity";
import { AccountOption } from "./account-option.entity";

export class User {
  id: number;

  firstname: string;

  lastname: string;

  mail: string;

  password: string;

  is_admin: boolean;

  role_retailer_id: number;

  role_site: string;

  valid: boolean;

  login_attempt: number;

  country: string;

  city: string;

  postal_code: string;

  address: string;

  need_subscription: boolean;

  connection_date: string;

  promo_code: string;

  short_code: string;

  is_security: boolean;

  disable_history: boolean;

  is_b2b: boolean;

  phone: string;

  sms: number;

  white_label: string;

  language: string;

  creation_date: string;

  site: string;

  bioggy_status: boolean;

  activate_sponsoring: boolean;

  account_option_offers: AccountOptionOffer[];

  account_options: AccountOption[];
}



// WEBPACK FOOTER //
// /app/src/app/entities/user.entity.ts